import React from "react";
import styled from "styled-components";

const Styled = styled.div<AssetIconProps>`
  box-sizing: border-box;
  display: flex;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "#333"};
  height: 14px;
  width: 14px;
  color: white;
  border-radius: 0.3rem;
  align-items: center;
  justify-content: center;
  padding: 2px;

  svg {
    fill: currentColor;
    display: block;
    width: 100%;
  }
`;
export interface AssetIconProps {
  size?: "small" | "normal";
  backgroundColor?: string;
}

const AssetIcon: React.FC<React.PropsWithChildren<AssetIconProps>> = (
  props,
) => {
  return (
    <Styled backgroundColor={props.backgroundColor}>{props.children}</Styled>
  );
};

export default AssetIcon;
